import { ChatBubbleBottomCenterTextIcon, MagnifyingGlassIcon, BeakerIcon } from '@heroicons/react/24/outline';

export const agents = {
    clarence: {
        name: 'Clarence',
        description: 'Creative Writing Agent',
        endpoint: 'https://aai.bigg.co.uk/webhook/clarence',
        icon: ChatBubbleBottomCenterTextIcon,
        color: 'text-green-400'
    },
    perry: {
        name: 'Perry',
        description: 'Internet Research Agent',
        endpoint: 'https://aai.bigg.co.uk/webhook/perry',
        icon: MagnifyingGlassIcon,
        color: 'text-blue-400'
    },
    dave: {
        name: 'Dave',
        description: 'General Purpose Agent',
        endpoint: 'https://aai.bigg.co.uk/webhook/dave',
        icon: BeakerIcon,
        color: 'text-purple-400'
    }
}


export const agentCaller = async ({
    userPrompt,
    systemPrompt,
    agentName,
    projectId, // Add projectId
    organizationId, // Add organizationId
    currentUserId, // Add currentUserId
  }) => {

    const agent = agents[agentName];

    if (!agent) {
        return {
            success: false,
            error: "No agent found",
        };
    }

    try {
      
      // Prepare the request payload
        const payload = {
            systemPrompt: `Today's date is ${new Date().toISOString().split('T')[0]}. You only ever write with British English spelling and grammar.` + cleanPrompt(systemPrompt),
            userPrompt: cleanPrompt(userPrompt),
            project_id: projectId, // Add project_id to payload
            organization_id: organizationId, // Add organization_id to payload
            current_user_id: currentUserId, // Add current_user_id to payload
        };

        console.log('AGENT CALLER PAYLOAD', payload)
  
        // Call endpoint
        const response = await fetch(`${agent.endpoint}`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });


  
        if (!response.ok) {
            throw new Error(`API Error: ${response.status}`);
        }
    
        let data = await response.json();

  
        return {
            success: true,
            output: data.result,
        };
  
    } catch (error) {
        console.error(`Error executing ${agentName} node:`, error);
        return {
            success: false,
            error: error.message,
        };
    }
};

const cleanPrompt = (prompt) => {
    return prompt.replace(/["\n\r\t]/g, ' ')
}